module.exports = __webpack_public_path__ + "img/Unleash-your-inner-genius-with-Smart-Blending.83a0c265.png";